import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponseIsOk } from '@/shared/api/validation'
import { z } from 'zod'
import { createManualInvoiceSchema } from '../schemas'

const client = createAssetManagementClient()

export async function createWheelingInvoice(invoiceDetails: z.infer<typeof createManualInvoiceSchema>) {
    await validateResponseIsOk(client
        .sendPost(`assets/${invoiceDetails.assetCode}/billing/invoices`,
            { data: createManualInvoiceSchema.parse(invoiceDetails)}))
}
    